export const getRequiredRule = (message = 'This field is required!') => ({
  required: true,
  message,
});
export const getEmailRule = (message = 'The input is not valid E-mail!') => ({
  message,
  type: 'email',
});

export const getNumberRule = (message = 'This field must be numeric!') => ({
  pattern: /^[0-9]+$/,
  message,
});

export const getMinLengthRule = (
  minLength = 5,
  message = `The length should be at least ${minLength} symbols`
) => ({
  min: minLength,
  message,
});
